import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { interactionTracker } from '../services/ai/InteractionTracker';

export const useInteractionCapture = () => {
  const location = useLocation();

  // Track page navigation
  useEffect(() => {
    interactionTracker.track({
      eventType: 'navigation',
      target: location.pathname,
      path: location.pathname,
      metadata: { search: location.search, hash: location.hash }
    });
  }, [location.pathname, location.search, location.hash]);

  // Track global clicks
  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      
      // Look for actionable elements (buttons, links, or elements with explicit roles)
      const actionableNode = target.closest('button, a, [role="button"], [role="link"], input[type="submit"]');
      
      if (actionableNode) {
        let textContent = actionableNode.textContent?.trim() || '';
        if (textContent.length > 50) textContent = textContent.substring(0, 50) + '...';
        
        const id = actionableNode.id;
        const className = actionableNode.className;
        
        interactionTracker.track({
          eventType: 'click',
          target: id ? `#${id}` : (textContent || target.tagName.toLowerCase()),
          path: window.location.pathname,
          metadata: { text: textContent, class: typeof className === 'string' ? className : undefined }
        });
      }
    };

    document.addEventListener('click', handleClick, { capture: true });
    
    return () => {
      document.removeEventListener('click', handleClick, { capture: true });
    };
  }, []);
};
